import { SET_SUPPLEMENTAL_TITLE } from '../actions/types';

// This reducer handles SUPPLEMENTAL title (new feature)
// Returns array directly, same structure as title reducer
export default function supplementalTitle(state = null, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_SUPPLEMENTAL_TITLE:
				return action.payload;

			// no default
		}
	}

	return state;
}
